import {
  Stack,
  Flex,
  Text,
  FormHelperText,
  FormErrorMessage,
  StackProps,
  FormHelperTextProps,
  FormErrorMessageProps,
  Box,
  FormErrorIcon
} from "@/storybook-components";

interface QuestionFooterProps extends StackProps {
  answerLength?: number;
  notes?: string;
  maxLength?: number;
  maxLengthNote?: string;
  error?: string;
  helperTextStyles?: FormHelperTextProps;
  errorMsgStyles?: FormErrorMessageProps;
  withErrorIcon?: boolean;
}

const QuestionFooter = (props: QuestionFooterProps) => {
  const {
    answerLength,
    notes,
    maxLength = null,
    maxLengthNote,
    error,
    helperTextStyles,
    errorMsgStyles,
    spacing,
    withErrorIcon,
    ...rest
  } = props;

  if (!maxLength && !error && !notes) {
    return null;
  }
  return (
    <Stack
      {...rest}
      spacing={spacing}
      direction="column"
      justifyContent={notes || error ? "space-between" : "flex-end"}
    >
      {error && (
        <FormErrorMessage {...{ mt: 0, ...errorMsgStyles }}>
          {withErrorIcon && <FormErrorIcon />} {error}
        </FormErrorMessage>
      )}
      {(maxLength || notes) && (
        <FormHelperText width="100%" {...{ mt: 0, ...helperTextStyles }}>
          <Stack spacing={spacing}>
            {maxLength && maxLengthNote && (
              <Flex
                justifyContent={maxLengthNote ? "space-between" : "flex-end"}
              >
                {maxLengthNote && <Text>{maxLengthNote}</Text>}
                <Text>{`${answerLength}/${maxLength}`}</Text>
              </Flex>
            )}
            {notes && <Box {...helperTextStyles}>{notes}</Box>}
          </Stack>
        </FormHelperText>
      )}
    </Stack>
  );
};

export { QuestionFooter };
export type { QuestionFooterProps };
